import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  permissionContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
    backgroundColor: '#1a1a1a',
  },
  permissionText: {
    color: 'white',
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 10,
  },
  permissionHint: {
    color: '#ccc',
    fontSize: 14,
    textAlign: 'center',
  },
  page2: {
    flex: 1,
    position: 'absolute',
    top: 0,
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backHeader: {
    backgroundColor: '#00000090',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'center',
    zIndex: -10,
  },
  footer: {
    backgroundColor: '#00000090',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '10%',
    height: '20%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  footerLandscape: {
    backgroundColor: '#00000090',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '5%',
    height: '5%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeButton: {
    paddingVertical: 10,
    paddingHorizontal: 10,
    borderWidth: 1,
    borderRadius: 5,
    borderColor: 'snow',
    alignItems: 'center',
    width: 90,
    height: 50,
    marginTop: 10,
  },
  closeText: {
    color: 'snow',
    fontSize: 16,
  },
  hiddenInput: {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
  },
  container: {
    flex: 1,
    position: 'absolute',
    top: 10,
    height: '100%',
  },
  scannerContainer: {
    alignItems: 'center',
  },
  scannerFrame: {
    width: 130,
    height: 250,
    borderColor: '#24E016',
    borderWidth: 2,
    borderRadius: 10,
    overflow: 'hidden',
  },
  scanLine: {
    position: 'absolute',
    left: 0,
    width: '100%',
  },

  instructionText: {
    fontSize: 17,
    textAlign: 'center',
    width: 300,
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.49)',
    marginVertical: 10,
    borderRadius: 10,
  },

  reminderContainer: {
    position: 'absolute',
    bottom: "17%",
    backgroundColor: 'rgba(233, 233, 233, 0.77)',
    padding: 10,
    borderRadius: 10,
    alignItems: 'center',
    zIndex: 10,
  },
  reminderContainerLandscape: {
    position: 'absolute',
    left: 20,
    right: 20,
    bottom: "20%",
    backgroundColor: 'rgba(233, 233, 233, 0.77)',
    padding: 10,
    borderRadius: 10,
    alignItems: 'center',
    zIndex: 100,
  },
  reminderText: {
    color: 'rgb(59, 59, 59)',
    fontSize: 16,
    textAlign: 'center',
  },
});
